import React from "react";
import PieChartsRow from "../../view/app/dashboard/PieChartsRow";

const SingleProgressLine = (props) => {
  return (
    <div key={props.name} className="mb-12">
      <div className="flex justify-between text-sm h-[30px]">
        <span>{props.name}</span>
        <span>{props.current}</span>
      </div>
      <div className="h-1.5 bg-gray-700 rounded">
        <div
          className="h-full bg-[#5A3EFF] rounded"
          style={{ width: `${(props.current / props.total) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};
export default SingleProgressLine;
